var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDonwloadPdfIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9V1H12.3336L17 6.09703V9",
    stroke: "#2A2A2A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5186 13.8613H2.87063V12.897H4.5186C4.77327 12.897 4.98057 12.8585 5.14048 12.7816C5.30039 12.7019 5.41736 12.592 5.49139 12.4519C5.56543 12.3118 5.60244 12.1538 5.60244 11.978C5.60244 11.7995 5.56543 11.6332 5.49139 11.4794C5.41736 11.3255 5.30039 11.2019 5.14048 11.1085C4.98057 11.0151 4.77327 10.9684 4.5186 10.9684H3.33259V16H2V10H4.5186C5.02499 10 5.45882 10.0852 5.8201 10.2555C6.18434 10.4231 6.46271 10.6552 6.65519 10.9519C6.84768 11.2486 6.94392 11.5879 6.94392 11.9698C6.94392 12.3571 6.84768 12.6923 6.65519 12.9753C6.46271 13.2582 6.18434 13.4766 5.8201 13.6305C5.45882 13.7843 5.02499 13.8613 4.5186 13.8613Z",
    fill: "#2A2A2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84897 16H8.44087L8.44975 15.0357H9.84897C10.1984 15.0357 10.4931 14.9629 10.7329 14.8173C10.9728 14.669 11.1534 14.4533 11.2748 14.1703C11.3992 13.8874 11.4614 13.5453 11.4614 13.1442V12.8516C11.4614 12.544 11.4259 12.2734 11.3548 12.0398C11.2867 11.8063 11.1845 11.6099 11.0483 11.4505C10.9121 11.2912 10.7448 11.1717 10.5464 11.092C10.348 11.0096 10.1199 10.9684 9.8623 10.9684H8.41421V10H9.8623C10.2947 10 10.69 10.0687 11.0483 10.206C11.4096 10.3407 11.722 10.5343 11.9856 10.7871C12.2491 11.0398 12.452 11.342 12.5941 11.6937C12.7392 12.0426 12.8118 12.4313 12.8118 12.8599V13.1442C12.8118 13.5701 12.7392 13.9588 12.5941 14.3104C12.452 14.6621 12.2491 14.9643 11.9856 15.217C11.725 15.467 11.4125 15.6607 11.0483 15.7981C10.687 15.9327 10.2872 16 9.84897 16ZM9.196 10V16H7.86341V10H9.196Z",
    fill: "#2A2A2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1127 10V16H13.7801V10H15.1127ZM17.6891 12.5632V13.5275H14.7485V12.5632H17.6891ZM18 10V10.9684H14.7485V10H18Z",
    fill: "#2A2A2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99991 3L9.99991 7.59996M9.99991 7.59996L7.59991 5.26133M9.99991 7.59996L12.3999 5.26133",
    stroke: "#2A2A2A",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17L3 19H17V17",
    stroke: "#2A2A2A",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonwloadPdfIcon);
export default __webpack_public_path__ + "static/media/donwload_pdf_icon.8c98d234.svg";
export { ForwardRef as ReactComponent };